// src/store/slices/assuranceListSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AssuranceListState {
  batchID: number;
  doctypeID: number;
  processId: number;
}
const initialState: AssuranceListState = {
  batchID: 0,
  doctypeID: 0,
  processId: 0
};

const assuranceListSlice = createSlice({
  name: 'assuranceList',
  initialState,
  reducers: {
    setAssuranceBatchID: (state, action: PayloadAction<number>) => {
      state.batchID = action.payload;
    },
    setAssuranceDoctypeID: (state, action: PayloadAction<number>) => {
      state.doctypeID = action.payload;
    },
    setAssuranceProcessId: (state, action: PayloadAction<number>) => {
      state.processId = action.payload;
    },
    setassuranceList: (state, action: PayloadAction<{ batchID: number; doctypeID: number }>) => {
      state.doctypeID = action.payload.doctypeID;
      state.batchID = action.payload.batchID;
    },

    resetAssuranceState: () => initialState
  }
});

export const { setAssuranceBatchID, setAssuranceDoctypeID, setAssuranceProcessId, setassuranceList, resetAssuranceState } = assuranceListSlice.actions;
export default assuranceListSlice.reducer;
